// extracted by mini-css-extract-plugin
export default {"personalTransaction":"PersonalTransaction_personalTransaction__DWZUq","personalTable":"PersonalTransaction_personalTable__Dl0KI"};